module.exports = __webpack_public_path__ + "img/logo-creditvisor.61970f71.png";